import { render, staticRenderFns } from "./FullSyncResource.vue?vue&type=template&id=6723026a"
import script from "./FullSyncResource.vue?vue&type=script&lang=js"
export * from "./FullSyncResource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports